export const UPLOAD_MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const UPLOAD_MAX_FILE_SIZE_MESSAGE =
  'The file size is too big, 50MB max.';
